import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class UsersRequest extends GenericRequest {

    term;
    page;
    filter;

    constructor(page, term = '', filter = 0) {
        super(METHOD_POST, ApiEndpoints.USERS);

        this.page = page;
        this.term = term;
        this.filter = filter;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) {
            request.criteria.role_ids = Array.isArray(this.filter) ? this.filter : [this.filter];
        }
        ;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/ws/UsersRequest.js